import BaseItemView from 'app/src/views/base/BaseItemView';

import paymentServiceDegradationTemplate from './templates/payment-service-degradation.hbs';

// configure
let View = BaseItemView.extend({
  template: paymentServiceDegradationTemplate,
});

// Defined
export default class PaymentServiceDegradationView extends View {}
